export const MINIMUM_DISPLAYED_ITEMS = 4;
export const VLU_HEADING = 'Value Lineup';
export const DEAL_LOVERS_HEADING = 'Deal Lover\'s™ Menu';
